module.exports = __webpack_public_path__ + "static/media/check-icon.d323c681.svg";